import ActivePharmacistBlock from './ActivePharmacistBlock';
import activeUsersReducer from './reducer';

export { activeUsersReducer };
export default ActivePharmacistBlock;
